module.exports = __webpack_public_path__ + "product-deposit-auto-complete-item.component.html";


//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-deposits/product-deposit-auto-complete/product-deposit-auto-complete-item.component.html
// module id = 947
// module chunks = 0